var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CopyCustomFieldAsPublicApi } from './apis/copy-custom-field-as-public-api.interface';
let SaveCustomFieldAsPublicRepositoryImpl = class SaveCustomFieldAsPublicRepositoryImpl {
    constructor(_copyCustomFieldAsPublicApi) {
        this._copyCustomFieldAsPublicApi = _copyCustomFieldAsPublicApi;
    }
    saveAsCompanyCustomField(customFields) {
        return this._copyCustomFieldAsPublicApi.copyCustomFieldAsPublic({
            field_list: customFields.map(this._formatField),
        });
    }
    _formatField(field) {
        return {
            ...field,
            created_by: field.created_by.email || field.created_by.mobile_number || '',
        };
    }
};
SaveCustomFieldAsPublicRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(CopyCustomFieldAsPublicApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof CopyCustomFieldAsPublicApi !== "undefined" && CopyCustomFieldAsPublicApi) === "function" ? _a : Object])
], SaveCustomFieldAsPublicRepositoryImpl);
export { SaveCustomFieldAsPublicRepositoryImpl };
